import { Amplify } from "aws-amplify";

export default function configureAuth() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID! || "eu-west-1_s0CYU3XEY",
        userPoolClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID! || "4fr3e0gp12govtmsekhoidonmm",
      },
    },
  });
}
